import { css } from 'styled-components';

import { colorWhite } from './variables';

export const SectionStyles = css`
  background-color: ${colorWhite};
`;

export default SectionStyles;
